import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import OWNERSHIP_SUMMARY_QUERY from "react-migration/domains/sites/apollo/li-api/queries/ownershipSummary.gql";

import { Stores, useGlobalState } from "react-migration/lib/persistence/state";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { withSkeletonLoading } from "@landtechnologies/components";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";
import { routedClient } from "react-migration/lib/persistence/apollo";
import { OwnershipSummaryResponseData } from "react-migration/domains/sites/typings";
import logSiteCardEvent from "src/js/view/sites/logSiteCardEvent";

export const Ownership = withSkeletonLoading(({ hideSkeletonLoading }) => {
  const { t } = useTranslation();
  const [{ siteCardId }] = useGlobalState(Stores.site);
  const { loading, data } = useQuery<OwnershipSummaryResponseData>(OWNERSHIP_SUMMARY_QUERY, {
    variables: { _id: siteCardId },
    client: routedClient,
  });

  useEffect(() => {
    if (!loading) hideSkeletonLoading();
  }, [loading]);

  const goToOwnershipTab = () => {
    router.push({
      name: ROUTES.SITES,
      query: {
        card_page: "ownership",
        site_id: siteCardId,
      },
    });

    logSiteCardEvent({
      name: "Site Card Summary Tab - Ownership Tab Link Clicked",
      context: { source: "sitecard-lite" },
    });
  };

  const numberOfRegisteredTitles = data?.ownershipSummary.totalNumberOfTitlesSummary;
  const exceedsMaxNumberOfTitles = numberOfRegisteredTitles == "50+";
  const ownershipSummaryString = exceedsMaxNumberOfTitles
    ? t("sites.card.summary.ownership.registered_titles_exceeds_limit", {
        limit: numberOfRegisteredTitles,
      })
    : t("sites.card.summary.ownership.registered_titles", {
        count: numberOfRegisteredTitles ?? 0,
      });

  return (
    <div className="atlas-p-4">
      <div className="atlas-pb-4 atlas-flex atlas-justify-between">
        <span className="atlas-font-medium atlas-text-xl atlas-text-neutral-800">
          {t("sites.card.summary.ownership")}
        </span>
      </div>

      <div className="atlas-border atlas-border-border-divider-subtle atlas-text-sm atlas-rounded-md atlas-drop-shadow-sm">
        <div
          className="atlas-p-2 atlas-border-b atlas-border-border-divider-subtle atlas-flex atlas-items-center atlas-justify-between hover:atlas-underline hover:atlas-cursor-pointer"
          onClick={goToOwnershipTab}
          data-testid="ownership-summary"
        >
          <span className="atlas-font-medium atlas-text-neutral-900">{ownershipSummaryString}</span>
          <i className="icon-lt-arrow-right-s-line" />
        </div>
      </div>
    </div>
  );
});
